import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { inicioReducer } from "../Reducers/InicioReducer";
import { PrincipalReducer } from "../Reducers/PrincipalReducer";
import { PopupReducer } from "../Reducers/PopupReducer";

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const reducers = combineReducers({
    inicio: inicioReducer,
    principal: PrincipalReducer,
    popup: PopupReducer
})

export const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))
);